import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { fireClick, fireClickLeave, goLink } from '../../helper/navbar-helper';
import { MenuItemInterface } from '../../../store/main/main.model';

@Component({
  selector: 'app-main-nav-bar',
  templateUrl: './main-nav-bar.component.html',
  styleUrls: ['./main-nav-bar.component.scss', '../../../../assets/icon/icofont/css/icofont.scss'],
})
export class MainNavBarComponent {
  @Input() newMenuItems: MenuItemInterface[];
  @Input() itemBorder: boolean = false;

  public itemBorderStyle: string;
  public subItemBorder: boolean;
  public windowWidth: number;
  public dropDownIcon: string;
  public subItemIcon: string;
  public megaMenuKeys: string[] = ['navigation_reports', 'navigation_settings'];
  public singleRowMenuKeys: string[] = [
    'navigation_dashboards',
    'shift_tracker',
    'sch_header_nav_scheduler',
    'embed_page',
  ];
  public customReportsKey: string = 'navigation_reports_custom_report';

  fireClick = fireClick;
  fireClickLeave = fireClickLeave;
  goLink = goLink;

  constructor(public router: Router) {
    this.itemBorderStyle = 'none';
    this.subItemBorder = true;
    this.windowWidth = window.innerWidth;
    this.dropDownIcon = 'style1';
    this.subItemIcon = 'style1';
  }
}
